
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface HebrewLegalDialogsProps {
  termsOpen: boolean;
  setTermsOpen: (value: boolean) => void;
  privacyPolicyOpen: boolean;
  setPrivacyPolicyOpen: (value: boolean) => void;
  openFullTerms?: () => void;
  openFullPrivacy?: () => void;
}

export const HebrewLegalDialogs = ({
  termsOpen,
  setTermsOpen,
  privacyPolicyOpen,
  setPrivacyPolicyOpen,
  openFullTerms,
  openFullPrivacy
}: HebrewLegalDialogsProps) => {
  const navigate = useNavigate();

  const handleFullTermsClick = () => {
    setTermsOpen(false);
    if (openFullTerms) {
      openFullTerms();
    } else {
      // Navigate to Hebrew terms page
      navigate("/he/terms");
    }
  };

  const handleFullPrivacyClick = () => {
    setPrivacyPolicyOpen(false);
    if (openFullPrivacy) {
      openFullPrivacy();
    } else {
      // Navigate to Hebrew privacy page
      navigate("/he/privacy");
    }
  };

  return (
    <>
      <Dialog open={termsOpen} onOpenChange={setTermsOpen}>
        <DialogContent className="max-w-md" dir="rtl">
          <DialogHeader>
            <DialogTitle>תנאי שימוש</DialogTitle>
          </DialogHeader>
          <DialogDescription>
            <div className="max-h-[60vh] overflow-y-auto">
              <p className="mb-4">תנאים אלה מסדירים את השימוש שלך בשירות Lainasampo.fi להשוואת הצעות הלוואה.</p>
              <p className="mb-4">בשימוש בשירות שלנו, אתה מבין שנשתף את פרטי הבקשה שלך עם בנקים ומוסדות פיננסיים שותפים למטרת הגשת הצעות הלוואה.</p>
              <p className="mb-4">עליך לספק מידע מדויק וכנה בבקשת ההלוואה שלך. מתן מידע שקרי עלול להוביל לדחיית הבקשה שלך ועשוי להיחשב כהונאה.</p>
              <p className="mb-4">Lainasampo.fi אינה מבטיחה שתקבל הצעות הלוואה או שתאושר לקבלת הלוואה כלשהי. ההחלטה לאישור הלוואות מתקבלת אך ורק על ידי המוסדות הפיננסיים השותפים שלנו בהתאם לקריטריונים שלהם.</p>
            </div>
          </DialogDescription>
          <div className="flex flex-col md:flex-row justify-between mt-4 gap-2">
            <Button 
              type="button" 
              variant="outline" 
              onClick={handleFullTermsClick}
              className="w-full md:w-auto"
            >
              קרא את התנאים המלאים
            </Button>
            <Button 
              type="button" 
              variant="outline" 
              onClick={() => setTermsOpen(false)}
              className="w-full md:w-auto"
            >
              סגור
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      
      <Dialog open={privacyPolicyOpen} onOpenChange={setPrivacyPolicyOpen}>
        <DialogContent className="max-w-md" dir="rtl">
          <DialogHeader>
            <DialogTitle>מדיניות פרטיות</DialogTitle>
          </DialogHeader>
          <DialogDescription>
            <div className="max-h-[60vh] overflow-y-auto">
              <p className="mb-4">מדיניות פרטיות זו מתארת כיצד Lainasampo.fi אוספת, משתמשת ומשתפת את המידע האישי שלך בעת השימוש בשירות שלנו.</p>
              <p className="mb-4">אנו אוספים את המידע האישי שאתה מספק בבקשת ההלוואה שלך, כולל שמך, פרטי יצירת קשר, מידע פיננסי ופרטי תעסוקה.</p>
              <p className="mb-4">אנו משתפים את המידע שלך עם בנקים ומוסדות פיננסיים שותפים למטרת יצירת הצעות הלוואה עבורך. אנו עשויים גם להשתמש במידע שלך לשיפור השירות שלנו ולתקשר איתך בנוגע לבקשתך.</p>
              <p className="mb-4">אנו מיישמים אמצעי אבטחה מתאימים להגנה על המידע האישי שלך ושומרים עליו רק כל עוד נדרש למטרות המפורטות במדיניות זו.</p>
            </div>
          </DialogDescription>
          <div className="flex flex-col md:flex-row justify-between mt-4 gap-2">
            <Button 
              type="button" 
              variant="outline" 
              onClick={handleFullPrivacyClick}
              className="w-full md:w-auto"
            >
              קרא את מדיניות הפרטיות המלאה
            </Button>
            <Button 
              type="button" 
              variant="outline" 
              onClick={() => setPrivacyPolicyOpen(false)}
              className="w-full md:w-auto"
            >
              סגור
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
